import { render } from "./ViewSlot.vue?vue&type=template&id=e89b3ffc"
import script from "./ViewSlot.vue?vue&type=script&lang=js"
export * from "./ViewSlot.vue?vue&type=script&lang=js"

import "./ViewSlot.vue?vue&type=style&index=0&id=e89b3ffc&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__